import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Pagination, Mousewheel} from "swiper/modules";

import slider1 from "../../assets/image/stella/slider1.png";
import slider2 from "../../assets/image/stella/slider2.png";
import slider3 from "../../assets/image/stella/slider3.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function VerticalSlider() {
    const slides = [
        {
            title: "Canales HOT",
            subtitle: "Contenido para adultos HD (+18)",
            text: "Ofrecemos una ventaja adicional con una amplia selección de canales para adultos (+18). Además, puede configurar un control parental con la clave que elija para restringir el acceso al contenido, asegurando que solo usted pueda verlo.",
            img: slider1,
        },
        {
            title: "Canales Deportivos",
            subtitle: "Viva el fútbol en directo AQUÍ",
            text: "Ofrecemos todos los canales latinos y españoles para disfrutar de múltiples ligas de fútbol y otros deportes, con visualización HD y FULL HD.",
            img: slider2,
        },
        {
            title: "Películas y Series",
            subtitle: "Contenido Premium",
            text: "Disfruta estrenos, contenido on demand y miles de títulos disponibles.",
            img: slider3,
        },
    ];

    return (
        <section className="w-full  bg-[#111] ">
            <div className="container relative px-6 flex items-center justify-center">
                <Swiper
                    direction="vertical"
                    slidesPerView={1}
                    spaceBetween={50}
                    mousewheel={true}
                    modules={[Navigation, Pagination, Mousewheel]}
                    pagination={{
                        clickable: true,
                        verticalClass: "my-pagination",
                        bulletClass: "my-bullet",
                        bulletActiveClass: "my-bullet-active",
                    }}
                    navigation={{
                        nextEl: ".next-btn",
                        prevEl: ".prev-btn",
                    }}
                    className="w-full max-w-[1400px] h-[80vh]"
                >
                    {slides.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="grid grid-cols-1 md:grid-cols-2 h-full gap-10 items-center">

                                {/* Textos */}
                                <div className="text-white">
                                    <h4 className="text-lg font-semibold">{item.title}</h4>
                                    <h2 className="text-4xl md:text-5xl font-bold mt-4 leading-tight">
                                        {item.subtitle}
                                    </h2>
                                    <p className="mt-6 text-base md:text-lg leading-relaxed opacity-80 max-w-[90%]">
                                        {item.text}
                                    </p>
                                </div>

                                {/* Imagen */}
                                <div
                                    className="flex justify-center items-center bg-black h-[650px] md:h-[700px] rounded-xl">
                                    <img
                                        src={item.img}
                                        alt=""
                                        className="max-h-[500px] md:max-h-[550px] object-contain"
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="z-10 absolute right-0 bottom-0 flex flex-col gap-4">
                        <button
                            className="prev-btn w-12 h-12 border-2 border-yellow-400 rounded-full text-yellow-400 flex items-center justify-center text-xl hover:bg-yellow-400 hover:text-black transition">
                            ‹
                        </button>

                        <button
                            className="next-btn w-12 h-12 border-2 border-yellow-400 rounded-full text-yellow-400 flex items-center justify-center text-xl hover:bg-yellow-400 hover:text-black transition">
                            ›
                        </button>
                    </div>
                </Swiper>

                {/* Flechas */}


                {/* BULLETS VERTICALES */}
                <style>{`
                .my-pagination {
                    position: absolute;
                    right: 3.5rem;
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                }

                .my-bullet {
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    border: 2px solid #ccc;
                    opacity: .5;
                    cursor: pointer;
                }

                .my-bullet-active {
                    border-color: #f2c200;
                    background-color: #f2c200;
                    opacity: 1;
                }
            `}</style>
            </div>
            <div className="container text-white">

                <p>Comprar cuentas Stella TV oficial, Stella TV latino apk, link de Stella TV 2025. Aquí la página web
                    oficial de Stella TV. Puedes descargar la aplicación o comprar planes con descuentos, ofertas,
                    cupones, black friday, etc.</p>
            </div>
        </section>
    );
}

export default VerticalSlider;
